import React from 'react';
import Hero from '../components/Hero';
import AboutUs from '../components/AboutUs';
import Footer from '../components/Footer';
import HeikeImage from '../assets/heike1.jpeg';

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Hero />
      {/* Sobre la Fundación */}
      <AboutUs
        showTeamSection={false}
        showIntroGrid={false}
        sectionTitle="Heike Paulmann Koepfer, Presidenta de la Fundación"
        headerImage={HeikeImage}
      />

      <Footer />
    </div>
  );
};

export default HomePage;
